import React from "react";
// import { Link } from 'react-router-dom';
import PropTypes from "prop-types";

export const UserItem = props => (
  <a
    href={props.link}
    className={`user__item hover-effect ${props.className}`}
    style={{ backgroundImage: `url(${props.img})` }}
    target="_blank"
    rel="noopener noreferrer"
  >
    <div className="user__item__overlay">
      <div className="user__item__name">{props.name}</div>
      <div className="user__item__category">{props.category}</div>
      <div className="user__item__description">{props.description}</div>
    </div>
  </a>
);

UserItem.propTypes = {
  category: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  img: PropTypes.any,
  link: PropTypes.string,
  description: PropTypes.string
};

UserItem.defaultProps = {
  className: "",
  link: "/"
};
